<template>
    <div class="slp-sidebar">
        <div class="slp-sidebar-logo">
            <div class="photo">
                <img :src="[collapse===true?logoDefaultPhoto:logoSmall]" alt="" />
            </div>
        </div>
        <div class="slp-sidebar-list">
            <el-menu
                class="sidebar-el-menu"
                :default-active="$route.path"
                :collapse="!collapse"
                unique-opened
                router
            >
                <template v-for="(item,index) in $router.options.routes" v-if="isPermissions(item)">

                    <el-submenu :index="index + ''" v-if="!item.leaf">
                        <template slot="title">
                            <i :class="item.meta.icon || ''"></i><span slot="title">{{item.meta.title}}</span>
                        </template>
                        <el-menu-item v-for="child in item.children"
                                      :index="item.path +'/'+ child.path"
                                      :class="{'is-active':$route.name === child.name}"
                                      :key="child.name"
                                      v-if="isPermissions(child)">{{child.meta.title}}
                        </el-menu-item>
                    </el-submenu>

                    <el-menu-item v-if="item.leaf&&item.children.length>0"
                                  :class="{'is-active':($route.matched[0].name === item.name)}"
                                  :index="item.path">{{item.meta.title}}
                    </el-menu-item>
                </template>
            </el-menu>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: "sideBar",
    data(){
        return{
            logoDefaultPhoto:require('@/assets/logo-sidebar.png'),
            logoSmall:require('@/assets/logo-sidebar-small.png'),
        }
    },
    computed:{
        ...mapState({
            collapse:state => state.global.open,
        }),
        user(){
            return this.$store.getters.getUsers
        },
    },
    methods:{
        isPermissions(routeObj){
            if (routeObj.meta.menuId && this.user.menuIdList){
                return this.user.menuIdList.includes(routeObj.meta.menuId)
            }
            return !routeObj.hidden
        },
    },
    components:{

    },
    mounted(){

    }
}
</script>



// WEBPACK FOOTER //
// src/layouts/components/sideBar.vue